import '.ag{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.hp{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.at{align-items:flex-start;}.ssr-plugin'
import '.e2{padding:2rem;}.ssr-plugin'
import '.dn{background:var(--palette-white);}.ssr-plugin'
import '.bd{overflow:hidden;}.ssr-plugin'
import '.bm{position:absolute;}.ssr-plugin'
import '.jp{top:50%;}.ssr-plugin'
import '.jq{right:1rem;}.ssr-plugin'
import '.jr{transform:translateY(-50%);}.ssr-plugin'
import '.js{width:120px;}.ssr-plugin'
import '.jt{height:120px;}.ssr-plugin'
import '.ju{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.j2{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jv{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jw{font-size:4rem;}.ssr-plugin'
import '.cz{font-weight:700;}.ssr-plugin'
import '.jx{line-height:100%;}.ssr-plugin'
import '.gv{margin:0px;}.ssr-plugin'
import '.a1{color:var(--brand-secondary);}.ssr-plugin'
import '.a2{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ag l hp d e ad at e2 dn bd"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bm jp jq jr js jt ju d r ad"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ag j2 d e at s jv"
      >
        <div className="jw cz jx gv a1 a2"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
